import styled from 'styled-components'

const Wrapper = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

type ListBoxProps<T> = {
  data: T[]
  renderItem: (row: T, i: number, data: T[]) => React.ReactNode
}

const ListBox = <T extends {}>({ data = [], renderItem }: ListBoxProps<T>) =>
  data.length > 0 ? (
    <Wrapper>{data.map((row, index) => renderItem(row, index, data))}</Wrapper>
  ) : null

export default ListBox
